var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2655_6343)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 114,
    height: 114,
    rx: 28,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2655_6343)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2416 61.3281H45.8242V66.1054H51.8662V63.6953H48.2416V61.3281Z",
    fill: "#0D6CF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.838 57.0134H43.2104V54.6801H46.838V47.5664H40.793V49.9766H44.4206V52.3222H40.793V59.4236H46.838V57.0134Z",
    fill: "#0D6CF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3531 53.6695H34.2797C33.7514 51.7696 32.0067 50.3678 29.9364 50.3585V52.3906C30.4862 52.3967 30.3511 53.4789 30.8026 53.8016C31.2541 54.1214 32.2463 53.6602 32.4214 54.189C32.5842 54.7055 31.5091 54.9207 31.3371 55.4463C31.1743 55.9751 31.9207 56.7713 31.4692 57.0941C31.0176 57.4138 30.4893 56.4608 29.9364 56.4578V59.3844C32.0067 59.3721 33.7514 57.9733 34.2797 56.0704H36.3531V59.3844H39.0776V50.3555H36.3531V53.6664V53.6695ZM29.9364 50.3555H29.9118C27.4146 50.3555 25.375 52.3783 25.375 54.8622C25.375 57.3462 27.4115 59.3813 29.9118 59.3813H29.9364V56.4547H29.9333C29.3804 56.4547 28.846 57.4138 28.3975 57.091C27.9552 56.7683 28.6955 55.972 28.5296 55.4433C28.3545 54.9145 27.2794 54.7024 27.4545 54.1859C27.6173 53.6572 28.6217 54.1214 29.061 53.7986C29.5125 53.4758 29.3774 52.3875 29.9303 52.3875H29.9333V50.3555H29.9364Z",
    fill: "#0D6CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0482 50.3555H49.3359V59.3813H52.0482V50.3555Z",
    fill: "#0D6CF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9431 50.3546V52.9677C86.9874 52.9677 87.8475 53.8162 87.8475 54.8614C87.8475 55.9066 86.9874 56.7643 85.9431 56.7643V59.3774C88.4403 59.3774 90.4799 57.3546 90.4799 54.8583C90.4799 52.3621 88.4403 50.3516 85.9431 50.3516V50.3546ZM85.9431 50.3546C83.4428 50.3546 81.4062 52.3775 81.4062 54.8614C81.4062 57.3454 83.4428 59.3805 85.9431 59.3805V56.7674C84.8895 56.7674 84.0387 55.9066 84.0387 54.8645C84.0387 53.8223 84.8895 52.9708 85.9431 52.9708V50.3577V50.3546Z",
    fill: "#0D6CF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4002 54.529H78.5012V52.1188H74.0658V49.9453H78.5012V47.5352H71.6484V54.529H73.9828V56.7024H70.6562V59.1126H79.7207V56.7024H76.4002V54.529Z",
    fill: "#0D6CF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2468 66.5509C77.3018 66.5509 78.9789 64.9954 78.9789 63.0771C78.9789 61.1588 77.3018 59.6124 75.2468 59.6094V61.706C76.0547 61.706 76.7212 62.3208 76.7212 63.0771C76.7212 63.8333 76.0547 64.4543 75.2468 64.4543V66.5509ZM75.2468 59.6124C73.1888 59.6124 71.5117 61.168 71.5117 63.0801C71.5117 64.9923 73.1888 66.554 75.2468 66.554V64.4574C74.4298 64.4574 73.7725 63.8333 73.7725 63.0801C73.7725 62.327 74.3776 61.7091 75.2468 61.7091V59.6124Z",
    fill: "#0D6CF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5642 50.3546V52.9677C59.6177 52.9677 60.4686 53.8162 60.4686 54.8614C60.4686 55.9066 59.6177 56.7643 58.5642 56.7643V59.3774C61.0614 59.3774 63.101 57.3546 63.101 54.8583C63.101 52.3621 61.0614 50.3516 58.5642 50.3516V50.3546ZM58.5642 50.3546C56.0669 50.3546 54.0273 52.3775 54.0273 54.8614C54.0273 57.3454 56.0638 59.3805 58.5642 59.3805V56.7674C57.5198 56.7674 56.6597 55.9066 56.6597 54.8645C56.6597 53.8223 57.5198 52.9708 58.5642 52.9708V50.3577V50.3546Z",
    fill: "#0D6CF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.3099 53.6695V50.3555H91.5977V59.3813H94.3099V56.0673H96.6229V53.6695H94.3099Z",
    fill: "#0D6CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0878 50.3555H65.3633V59.3813H68.0878V50.3555Z",
    fill: "#0D6CF9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2655_6343",
    x: 0,
    y: 0,
    width: 122,
    height: 122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2655_6343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2655_6343",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2655_6343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.25,
    height: 19.0139,
    fill: "white",
    transform: "translate(25.375 47.5352)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBox);
export default __webpack_public_path__ + "static/media/logo_box.1ce5b6c3e5cda7982a6916c15310f42b.svg";
export { ForwardRef as ReactComponent };